export default __webpack_public_path__ + "static/media/chevron-down-bg.7b967382.svg";